export * from './TechCamPhotoIcon';
export * from './TechCamPhotoIcon16Light';
export * from './TechCamPhotoIcon16Regular';
export * from './TechCamPhotoIcon16Solid';
export * from './TechCamPhotoIcon20Light';
export * from './TechCamPhotoIcon20Regular';
export * from './TechCamPhotoIcon20Solid';
export * from './TechCamPhotoIcon24Regular';
export * from './TechCamPhotoIcon24Solid';
export * from './TechCamPhotoIcon32Regular';
export * from './TechCamPhotoIcon64Regular';
